import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import RunEventListPage from './run-event-list';
import PageHeader from '@/components/PageHeader';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title="Run Events">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>            
            <Breadcrumb.Item active>Run Events</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <RunEventListPage />
    </Panel>
  );
};

export default Page;
